<template>
  <v-app>
    <navigation :color="color" :flat="flat" />
    <v-main>
      <home />
      <about />
      <skill />
      <project />
      <contact />
      <!-- <onprogress /> -->
      <foot />
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="#7F5AF0"
        @click="toTop"
        title="back to top"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
  </v-app>
</template>

<script>
import navigation from "@/components/PortfolioNavbar";
import home from "@/components/PortfolioHome";
import about from "@/components/PortfolioAbout";
import skill from "@/components/PortfolioSkill";
import project from "@/components/PortfolioProject";
import contact from "@/components/PortfolioContact";
// import onprogress from "@/components/PortfolioOnProgress";
import foot from "@/components/PortfolioFooter";

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title,
    };
  },
  mounted() {
    document.title = this.$route.meta.title;
  },

  name: "App",
  components: {
    navigation,
    home,
    about,
    skill,
    project,
    contact,
    // onprogress,
    foot,
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
    dialog: false,
  }),

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "#0E172C";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "#121F3E";
        this.flat = false;
      } else {
        this.color = "#0E172C";
        this.flat = true;
      }
    },

    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },

  computed: {
    size() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size
        ? {
            [size]: true,
          }
        : {};
    },
  },
};
</script>
